export default "__VITE_ASSET__DO1pw2or__"